// import { Navigate, Outlet } from "react-router-dom";
// import { permissions } from "../../roles";

// const ProtectedRoute = ({ requiredPermission }: any) => {
//   const role = atob(sessionStorage.getItem("key") || "");
//   if (role === "NA") {
//     return <Navigate to="/Unauthorised" />;
//   }

//   if (!permissions[role?.toUpperCase()]?.includes(requiredPermission)) {
//     return <Navigate to="/dashboard" />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { permissions } from "../../roles";

const ProtectedRoute = ({ requiredPermission }: any) => {
  const location = useLocation();
  const token = sessionStorage.getItem("PBT_ACCESS_TOKEN");
  const encodedRole = sessionStorage.getItem("key");
  const role =  atob(encodedRole || "");

  // Case 1: No token and no role → Unauthorized
  if (!token && role === "NA") {
    return <Navigate to="/Unauthorised" />;
  }

  // Case 2: Role exists but doesn't have permission → Dashboard
  if (role && !permissions[role?.toUpperCase()]?.includes(requiredPermission)) {
    return <Navigate to="/dashboard" />;
  }

  // Case 3: Token and role are valid → Allow access
  return <Outlet />;
};

export default ProtectedRoute;

